import React, { PureComponent } from "react";
import { StyleSheet, Text, TextStyle, View } from "../platformComponents";
import {
  colors,
  flexDirection,
  fontFamily,
  fontSize,
  fontWeight,
  height,
  margin,
  radius,
} from "../styles/common";
import { IS_WEB } from "@adgm/libs";
import type { IFormItemLayout } from "@adgm/cross-models";

const FONT_FAMILY = IS_WEB ? "Common-Regular" : fontFamily.commonRegular;

export class AsFormItemLayout extends PureComponent<IFormItemLayout<any>> {
  _renderLabel = () => {
    const { label, labelElement, style } = this.props;
    let _labelElement;

    if (labelElement) {
      _labelElement = labelElement;
    } else {
      _labelElement =
        label == undefined ? undefined : (
          <Text style={[styles.label, style as TextStyle]}>{label}</Text>
        );
    }
    return _labelElement;
  };

  _renderSubLabel = () => {
    const { subLabel } = this.props;
    if (typeof subLabel === "string") {
      return <Text style={styles.subLabel}>{subLabel}</Text>;
    }
    return subLabel;
  };

  handleMarginTop = () => {
    const { horizontalLayout } = this.props;
    if (horizontalLayout) return 0;
    return IS_WEB ? margin.m12 : margin.m8;
  };

  containerMarginTop = () => {
    const { horizontalLayout } = this.props;
    if (horizontalLayout) return 0;
    return margin.m8;
  };

  render() {
    const {
      error,
      children,
      style,
      containerStyle,
      hideErrorSpace,
      required,
      label,
      subLabel,
      labelElement,
    } = this.props;
    return (
      <View style={[{ flex: 1, marginTop: this.containerMarginTop() }, style]}>
        {label || labelElement ? this._renderLabel() : null}
        {subLabel ? <View style={styles.subLabelContent}>{this._renderSubLabel()}</View> : null}
        <View
          style={[
            styles.container,
            {
              borderColor: required && error ? colors.red2 : colors.transparent,
              marginTop: this.handleMarginTop(),
            },
            containerStyle,
          ]}>
          {children}
        </View>
        {!hideErrorSpace ? (
          <Text style={styles.error}>{required && error ? error : ""}</Text>
        ) : undefined}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  label: {
    fontSize: IS_WEB ? fontSize.f14 : fontSize.f12,
    color: colors.white,
    fontFamily: FONT_FAMILY,
  },
  subLabelContent: {
    marginVertical: IS_WEB ? margin.m28 : margin.m12,
  },
  subLabel: {
    fontSize: IS_WEB ? fontSize.f14 : fontSize.f12,
    color: colors.white6,
    fontFamily: FONT_FAMILY,
  },
  container: {
    backgroundColor: IS_WEB ? colors.mainBackgroundWeb : "transparent",
    flexDirection: flexDirection.row,
    borderRadius: radius.r2,
    borderWidth: 0.5,
  },
  error: {
    marginTop: margin.m5,
    fontFamily: FONT_FAMILY,
    fontWeight: fontWeight.f500,
    fontSize: fontSize.f14,
    color: colors.red2,
    minHeight: height.h14,
  },
});
